import React, { useEffect, useState } from "react";
import "../Styling/EmployeeDistribution.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { useNavigate } from "react-router-dom";

import { Users } from "lucide-react";

const EmployeeDistribution = ({ filters }) => {
  const { user } = useAuth();
    const navigate = useNavigate();
  

  // ✅ prefer filters, fallback to logged-in user
  const orgId = filters?.orgId || user?.organisationId;
  const companyCode = Number(filters?.companyCode || user?.companyCode);
  const fiscalYear = filters?.fiscalYear || "All Fiscal Years";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId || !companyCode) return;

    const fetchDistribution = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams({
          orgId,
          companyCode
        });

        const res = await fetch(
          `${Base_URL}/Resource/employee-distribution?${params.toString()}`
        );

        if (!res.ok) {
          console.error("API failed:", res.status);
          setData([]);
          return;
        }

        const json = await res.json();
        setData(Array.isArray(json) ? json : []);

      } catch (err) {
        console.error("❌ Employee distribution error:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDistribution();
  }, [orgId, companyCode, fiscalYear]); // 🔥 wired to filters

  /* ================= Totals ================= */
  const totalEmployeesOverYears = data.reduce(
    (sum, item) => sum + (item.totalEmployees || 0),
    0
  );

  const totalLeftEmployees = data.reduce(
    (sum, item) => sum + (item.leftEmployees || 0),
    0
  );

  const totalPermanentEmployees = data.reduce(
    (sum, item) => sum + (item.permanent || 0),
    0
  );

  // const totalDummyEmployees = data.reduce(
  //   (sum, item) => sum + (item.dummy || 0),
  //   0
  // );

  // const totalPartialEmployees = data.reduce(
  //   (sum, item) => sum + (item.partial || 0),
  //   0
  // );

  // const totalInternEmployees = data.reduce(
  //   (sum, item) => sum + (item.intern || 0),
  //   0
  // );

  const totalInactiveEmployees = data.reduce(
    (sum, item) => sum + (item.inactive || 0),
    0
  );

  const totalActiveEmployees =
    totalEmployeesOverYears -
    totalInactiveEmployees -
    totalLeftEmployees;



  if (loading) {
    return (
      <div className="employee-distribution-card">
        <div className="text-center text-muted py-3">Loading…</div>
      </div>
    );
  }

  return (
    <div className="employee-distribution-card compact">
      {/* Header */}
      <div className="distribution-header">
        <div className="header-left">
          <div className="distribution-icon">
            <Users size={18} />
          </div>
          <h6>
            Employee Distribution
            <span className="fy-label">
              {fiscalYear === "All Fiscal Years" ? "All Years" : fiscalYear}
            </span>
          </h6>
        </div>
         <span
          className="view-all-tag-employee"
          onClick={() => navigate("/resourceList")}
        >
          View all
        </span>
      </div>

      <div className="row g-2 mt-2">
        {totalEmployeesOverYears > 0 && (
          <DistributionStat
            label="Total Employees"
            value={totalEmployeesOverYears}
            type="Total"
          />
        )}

        {totalActiveEmployees > 0 && (
          <DistributionStat
            label="Active Employees"
            value={totalActiveEmployees}
            type="Active"
          />
        )}

        {totalLeftEmployees > 0 && (
          <DistributionStat
            label="Left Employees"
            value={totalLeftEmployees}
            type="Left"
          />
        )}

        {totalInactiveEmployees > 0 && (
          <DistributionStat
            label="Inactive Employees"
            value={totalInactiveEmployees}
            type="Inactive"
          />
        )}

        {/* {totalPermanentEmployees > 0 && (
          <DistributionStat
            label="Permanent"
            value={totalPermanentEmployees}
            type="Permanent"
          />
        )}

        {totalDummyEmployees > 0 && (
          <DistributionStat
            label="Dummy"
            value={totalDummyEmployees}
            type="Dummy"
          />
        )}

        {totalPartialEmployees > 0 && (
          <DistributionStat
            label="Partial"
            value={totalPartialEmployees}
            type="Partial"
          />
        )}

        {totalInternEmployees > 0 && (
          <DistributionStat
            label="Intern"
            value={totalInternEmployees}
            type="Intern"
          />
        )} */}
      </div>
    </div>
  );
};

const DistributionStat = ({ label, value, type }) => {
  const colorMap = {
    Total: "#A3BFFA",
    Active: "#93C5FD",
    Left: "#FCA5A5",
    Inactive: "#FECACA",
    Permanent: "#93C5FD",
    Dummy: "#FECACA",
    Partial: "#FDE68A",
    Intern: "#C6F6D5",
  };

  return (
    <div className="col-6 col-md-3">
      <div
        className="distribution-stat compact"
        style={{
          backgroundColor: colorMap[type] || "#E5E7EB",
          color: "#1f2937",
        }}
      >
        <h5>{value}</h5>
        <span>{label}</span>
      </div>
    </div>
  );
};

export default EmployeeDistribution;
